import React from 'react'
import { observer } from 'mobx-react-lite'
import { sideNavAnalyticsProps } from '../side-nav-analytics-props'
import { useIsActive } from 'app/packs/src/utils/use-is-active'
import * as SideMenu from 'components/side-menu'
import { useStore } from 'store/context'

export const FeedbackLink = observer(() => {
  const { currentUser } = useStore()

  const path = `/feedback`
  const title = 'Feedback'

  const isActive = useIsActive(path)

  // Hidden where an admin has switched Feedback off for the account. The
  // controller redirects anyone who reaches the URL back to root, and a side-nav
  // click navigates a turbo frame that cannot paint that flash, so an offered
  // link just looks dead.
  if (!currentUser?.org?.feedbackEnabled) return null

  return (
    <SideMenu.LinkItem
      active={isActive}
      href={path}
      analyticsProps={sideNavAnalyticsProps({
        href: path,
        title,
      })}
    >
      {title}
    </SideMenu.LinkItem>
  )
})
